<template>
  <div id="app"><router-view /></div>
</template>

<script>
export default {
  name: 'App',
  data() {
    return {
      notify: {
        show: false,
        second: 0,
        interval: null
      }
    };
  },
  methods: {
  },
  mounted() {
    let _this = this;
    this.$nextTick(() => {/*
      window.addEventListener('resize', () => {
        _this.notify.second = 5;
        let text =
          '<span id="notifyText">您正在调整窗口，<strong style="color: #3385ff;">' +
          _this.notify.second +
          '</strong> 秒后将为您刷新网页重新适配大小';
        clearInterval(_this.notify.interval);
        _this.notify.interval = setInterval(function() {
          _this.notify.second -= 1;
          document.getElementById('notifyText').innerHTML =
            '<span id="notifyText">您正在调整窗口，<strong style="color: #3385ff;">' +
            _this.notify.second +
            '</strong> 秒后将为您刷新网页重新适配大小';
          if (_this.notify.second == 0) {
            clearInterval(_this.notify.interval);
            window.location.reload();
          }
        }, 1000);
        if (_this.notify.show == false) {
          this.$notify({
            title: '通知',
            dangerouslyUseHTMLString: true,
            message: text,
            type: 'warning',
            showClose: true,
            duration: 0,
            onClose: function(e) {
              clearInterval(_this.notify.interval);
               _this.notify.show = false;
            }
          });
          _this.notify.show = true;
        }
        //监听浏览器窗口大小改变
        //浏览器变化执行动作
      }); */
    });
  }
};
</script>

<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}
.el-message,.el-picker-panel,.el-date-picker,.el-popper{
  z-index: 999999999999999999 !important;
}
</style>



// WEBPACK FOOTER //
// src/App.vue